import { ExtendedEventBaseItem } from "./extended-event-base.item";
import { WaHelperService } from "../../wa-services/wa-helper-service";

export class SeriesStagesItem extends ExtendedEventBaseItem {
  id: number;
  name: string;
  nameshort: string;
  venue: string;
  place: string;
  countryname: string;
  comdis: number;
  level: string;
  sublevel: string;
  stage: number;
  isfinal: boolean;
  stagelevel: string;
  links: {
    Web: string;
    "Result URL": string;
    "Registration URL": string;
  };
  constructor(SeriesStagesItemraw: any, waHelperService: WaHelperService) {
    super(SeriesStagesItemraw, waHelperService);
    this.id = SeriesStagesItemraw.ID;
    this.name = SeriesStagesItemraw.Name;
    this.nameshort = SeriesStagesItemraw.CName;
    this.venue = SeriesStagesItemraw.Venue;
    this.place = SeriesStagesItemraw.Place;
    this.country = SeriesStagesItemraw.Country;
    this.countryname = SeriesStagesItemraw.CountryName;
    this.comdis = SeriesStagesItemraw.ComDis;
    this.level = SeriesStagesItemraw.Level;
    this.sublevel = SeriesStagesItemraw.SubLevel;
    this.stage = SeriesStagesItemraw.Stage;
    this.isfinal = SeriesStagesItemraw.isFinal;
    this.stagelevel = SeriesStagesItemraw.StageLevel;
    this.links = SeriesStagesItemraw.Links;
  }
}
